import { Column, Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';

export interface IPasswordRequirementsProps {
  testId?: string;
}

const BULLETS = [
  'Must be at least 8 characters',
  'Include at least one number (recommended)',
  'Include at least one capital letter (recommended)',
  'Include at least one special character (!@#$%^&*) (recommended)',
];

export const PasswordRequirements = ({ testId }: IPasswordRequirementsProps) => (
  <Column gap={1} data-testid={testId}>
    {BULLETS.map((text) => (
      <Typography key={text} size="body_large" color={colors.neutral[500]}>
        {`• ${text}`}
      </Typography>
    ))}
  </Column>
);
